import React from 'react';

function HamburgerIcon({ open, onClick }) {
  return (
    <button
      className={`hamburger ${open ? 'open' : ''}`}
      onClick={onClick}
      aria-label="Toggle menu"
    >
      <span className="hamburger-line" />
      <span className="hamburger-line" />
      <span className="hamburger-line" />
    </button>
  );
}

export default HamburgerIcon;
